import { render, staticRenderFns } from "./1.vue?vue&type=template&id=1f35858c&scoped=true"
import script from "./1.vue?vue&type=script&lang=js"
export * from "./1.vue?vue&type=script&lang=js"
import style0 from "./1.vue?vue&type=style&index=0&id=1f35858c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35858c",
  null
  
)

export default component.exports